import _export from '../internals/export.js';
import fails$1 from '../internals/fails.js';
import '../internals/object-get-own-property-names-external.js';
import { __exports as objectGetOwnPropertyNamesExternal } from '../../../../../../_virtual/object-get-own-property-names-external.js';

var $ = _export;
var fails = fails$1;
var getOwnPropertyNames = objectGetOwnPropertyNamesExternal.f; // eslint-disable-next-line es/no-object-getownpropertynames -- required for testing

var FAILS_ON_PRIMITIVES = fails(function () {
  return !Object.getOwnPropertyNames(1);
}); // `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames

$({
  target: 'Object',
  stat: true,
  forced: FAILS_ON_PRIMITIVES
}, {
  getOwnPropertyNames: getOwnPropertyNames
});
